export default __webpack_public_path__ + "static/media/tagImage.a24d62ca.svg";